import Button from '@components/v2/ui/Button/Button';
import Typography from '@components/v2/ui/Typography/Typography';
import { HIGHLIGHT_MAX_WIDTH } from '../highlights.constants';
import HighlightUnreadIndicator from './HighlightUnreadIndicator';

const BUTTON_STYLES = {
  minWidth: 0,
  justifyContent: 'flex-start',
  paddingBlock: 2,
  textTransform: 'none',
  maxWidth: HIGHLIGHT_MAX_WIDTH,
  display: 'flex',
  alignItems: 'center',
  gap: 1,
} as const;

interface HighlightButtonProps {
  title: string;
  isRead: boolean;
  testId?: string;
  onClick: () => void;
}

const HighlightButton = ({ title, isRead, testId, onClick }: HighlightButtonProps) => (
  <Button
    variant="text"
    color="secondary"
    shape="square"
    size="small"
    fullWidth
    testId={testId}
    sx={BUTTON_STYLES}
    onClick={onClick}
  >
    {!isRead && <HighlightUnreadIndicator />}
    <Typography variant="body2" noWrap>
      {title}
    </Typography>
  </Button>
);

export default HighlightButton;
